import * as z from 'zod';

export const isEmailValid = (email: string): boolean => {
  const parsed = z.string().email().safeParse(email);
  return parsed.success;
};
